import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const provideAppTranslationLoader = () =>
  provideTranslateHttpLoader({
    prefix: './assets/i18n/',
    suffix: '.json',
    failOnError: true,
  });
